
export function isTwitterUrl(link: string) {
    return link.indexOf('twitter.com') >= 0
}

export function tweetIDFromURl(link: string) {
    if (!isTwitterUrl(link)) {
        return false
    }

    const match = link.match(/.*\/status\/(\d+).*/)

    if (!match || !match[1]) {
        return false
    }

    return match[1]
}
